/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const RISK_CAPITAL_CAN_ABILITY = [
  //Route Access
  ["read", "Profile"],
  ["read", "DashboardOverview"],
  ["read", "UsersList"],
  ["read", "OrganizationProfile"],
  ["read", "MyProfile"],
  ["read", "UsersList"],
  ["read", "ProvisionalPolicies"],
  ["read", "AllEvent"],
  ["read", "ProvisionalPolicyDetail"],
  ["read", "ActualPolicies"],
  ["read", "ActualPolicyDetails"],
  ["read", "CreditUnions"],
  ["read", "CreditUnionUsers"],
  ["read", "HoldersDetail"],
  ["read", "Holders"],
  ["read", "PolicyDetail"],
  ["read", "Products"],
  ["read", "FHPDetail"],
  ["read", "FHPAnalytics"],
  ["read", "Activity"],
  ["read", "WeatherAnalytics"],
  ["read", "AnalyticsAPIDetail"],
  ["read", "Events"],
  ["read", "EventPolicies"],
  ["read", "EventPolicyDetails"],
  ["read", "ArchivedPolicyDetail"],
  ["read", "ArchivedPolicies"]
];

export const RISK_CAPITAL_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
